<template>
  <div id="Ordersucess">
    <Sidbar-admin />
  </div>
</template>

<script>
import SidbarAdmin from '../layouts/sidbar-admin.vue'
export default {
  components: { SidbarAdmin },
    name:"Ordersucess"
}
</script>

<style>

</style>